import api from './axios';

// Character interface
export interface Character {
  id: number;
  name: string;
  race: number;
  sex: number;
  level: number;
  class_id: number;
  class_name: string;
  create_time: string;
  delete_time: string | null;
  login_time: string | null;
  logout_time: string | null;
  is_admin: number;
  is_online: number;
}

// Character response interface
export interface CharactersResponse {
  page: number;
  size: number;
  total: number;
  characters: Character[];
}

// Character search params interface
export interface CharacterSearchParams {
  page?: number;
  size?: number;
  search?: string;
  online?: boolean;
  admin?: boolean;
}

/**
 * Get characters with pagination, search, and filters
 * @param params Search parameters
 * @returns Characters response
 */
export const getCharacters = async (params: CharacterSearchParams = {}): Promise<CharactersResponse> => {
  // Define query parameters
  const queryParams = new URLSearchParams();
  
  // Add parameters to query
  if (params.page) queryParams.append('page', params.page.toString());
  if (params.size) queryParams.append('size', params.size.toString());
  if (params.search) queryParams.append('search', params.search);
  if (params.online !== undefined) queryParams.append('online', params.online.toString());
  if (params.admin !== undefined) queryParams.append('admin', params.admin.toString());
  
  // Make API call
  const response = await api.get<CharactersResponse>(`/characters?${queryParams.toString()}`);
  return response.data;
}; 